import type { ComponentProps } from 'react';

import type { Sport } from '__generated__/globalTypes';
import { SeasonalityIcon } from 'atoms/icons/SeasonalityIcon';
import { useSportContext } from 'contexts/sport';

type Props = {
  sport?: Sport;
} & Omit<ComponentProps<typeof SeasonalityIcon>, 'sport'>;

export const SportSeasonalityIcon = ({ sport, ...props }: Props) => {
  const { sport: sportContext } = useSportContext();
  return <SeasonalityIcon {...props} sport={sport || sportContext} />;
};
